import styles from './FJAIAudioRight.module.less';
import FJAudioSwiper from '../../../../common/combineComponents/FJAudioSwiper/FJAudioSwiper.jsx';
import FJAudioPresetItem from './FJAudioPresetItem.jsx';
import FJLocalStore from '../../../../store/FJLocalStore.js';
import FJAIAudioHistoryContainer from '../container/FJAIAudioHistoryContainer.jsx';
import FJConstant from '../../../../constants/FJConstant.js';
import FJAutoLoading from '../../../../common/components/FJLoading/FJAutoLoading.jsx';
import FJButton from '../../../../common/components/FJButton/FJButton.jsx';
import FJOppsIcon from '../../../../assets/svg/oops.svg?react';
import { useState } from 'react';
import fireBase64 from '../../../../assets/base64/fire.js';
import PropTypes from 'prop-types';

const FJAIAudioRight = props => {
    const { historyList = [], historyListLoadStatus, onRetry, presetList, onUsePresetInfo } = props;
    const [isOpenSwiper, setIsOpenSwiper] = useState(true);

    const renderItem = item => {
        return (
            <FJAudioPresetItem
                key={item.name}
                item={item}
                onUse={() => {
                    onUsePresetInfo(item);
                }}
                setIsOpenSwiper={setIsOpenSwiper}
            />
        );
    };

    return (
        <div className={styles.app_right}>
            {historyListLoadStatus === FJConstant.LOADING && (
                <div className={styles.state_box}>
                    <FJAutoLoading shown strokeColor='#9FA2AF' />
                </div>
            )}
            {historyListLoadStatus === FJConstant.ERROR && (
                <div className={styles.state_box}>
                    <FJOppsIcon />
                    <div className={styles.retry_desc}>{FJLocalStore._('unknown-error-please-try-again')}</div>
                    <FJButton type='white' text='retry' className={styles.retry_btn} onClick={onRetry} />
                </div>
            )}
            {historyListLoadStatus === FJConstant.SUCCESS && historyList.length > 0 && <FJAIAudioHistoryContainer />}
            {historyListLoadStatus === FJConstant.SUCCESS && historyList.length === 0 && (
                <div className={styles.default_box}>
                    <div className={styles.title}>
                        {FJLocalStore._('FlexClip-ai-music')}
                        <img src={fireBase64} alt='' />
                    </div>
                    <div className={styles.desc}>{FJLocalStore._('innovative-ai-music-samples')}</div>
                    <div>
                        <FJAudioSwiper
                            direction='reverse'
                            renderItem={renderItem}
                            list={presetList}
                            isOpenSwiper={isOpenSwiper}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

FJAIAudioRight.propTypes = {
    historyList: PropTypes.array,
    historyListLoadStatus: PropTypes.string,
    onRetry: PropTypes.func,
    presetList: PropTypes.array,
    onUsePresetInfo: PropTypes.func,
};
export default FJAIAudioRight;
